import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import {
  loadIntelligenceSettingsEffect,
  updateIntelligenceSettingsEffect,
} from './intelligence-settings.effects';
import {
  IntelligenceSettingsNamespace,
  IntelligenceSettingsReducer,
} from './intelligence-settings.state';

export const provideIntelligenceEffects = provideEffects({
  loadIntelligenceSettingsEffect,
  updateIntelligenceSettingsEffect,
});
export const provideIntelligenceState = provideState(
  IntelligenceSettingsNamespace,
  IntelligenceSettingsReducer,
);

@NgModule({
  imports: [
    StoreModule.forFeature(IntelligenceSettingsNamespace, IntelligenceSettingsReducer),
    EffectsModule.forFeature({
      loadIntelligenceSettingsEffect,
      updateIntelligenceSettingsEffect,
    }),
  ],
})
export class IntelligenceSettingsModule {}
